import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { fmtNum, fmtUsd, pnlColor, fmtTime } from "../lib/format";

export default function GuardHistory({ base = "/guard" }) {
  const [rows, setRows] = useState([]);
  const [skips, setSkips] = useState([]);
  const [tab, setTab] = useState("history");
  const [confirmId, setConfirmId] = useState(null);
  const load = () => {
    api.get(`${base}/history?limit=100`).then((r) => setRows(r.data)).catch(() => {});
    api.get(`${base}/skips?limit=60`).then((r) => setSkips(r.data)).catch(() => {});
  };
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, [base]); // eslint-disable-line react-hooks/exhaustive-deps
  const del = async (row) => {
    try {
      await api.delete(`${base}/history/${row.trade_id}`);
      toast.success(`${row.symbol} kaydı silindi; bakiye ve raporlar güncellendi`);
      setConfirmId(null); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const btn = (id, label, n) => (
    <button key={id} data-testid={`guard-subtab-${id}`} onClick={() => setTab(id)} className={`text-xs font-semibold px-3 py-1.5 rounded-md border transition-colors ${tab === id ? "border-[#3B82F6] text-[#3B82F6] bg-[#3B82F6]/10" : "border-[#1E2738] text-[#64748B] hover:text-[#94A3B8]"}`}>{label} <span className="text-[#64748B]">({n})</span></button>
  );
  return (
    <div className="space-y-2">
      <div className="flex gap-2">{btn("history", "Kapanan İşlemler", rows.length)}{btn("skips", "Atlanan Sinyaller", skips.length)}</div>
      {tab === "history" && (
        <div className="bg-[#121724] border border-[#1E2738] rounded-lg overflow-x-auto">
          <table data-testid="guard-history-table" className="w-full text-xs min-w-[860px]">
            <thead><tr className="text-[10px] uppercase text-[#64748B] border-b border-[#1E2738]">{["Kapanış", "Sembol", "Yön", "Giriş→Çıkış", "Brüt ROI", "Süre", "Net", "Neden", ""].map((h, i) => <th key={i} className="text-left px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={9} className="text-center text-[#64748B] py-6">Kapanan işlem yok.</td></tr>}
              {rows.map((p) => (
                <tr key={p.trade_id} data-testid={`history-row-${p.trade_id}`} className="border-b border-[#1E2738]/60 font-mono">
                  <td className="px-3 py-1.5 text-[#64748B]">{fmtTime(p.close_time)}</td><td className="px-3 py-1.5 font-semibold">{p.symbol}</td>
                  <td className={`px-3 py-1.5 ${p.side === "LONG" ? "text-[#10B981]" : "text-[#EF4444]"}`}>{p.side}</td>
                  <td className="px-3 py-1.5">{fmtNum(p.entry_price, 6)} → {fmtNum(p.exit_price, 6)}</td>
                  <td className={`px-3 py-1.5 ${pnlColor(p.gross_roi_final)}`}>%{Number(p.gross_roi_final || 0).toFixed(1)}</td>
                  <td className="px-3 py-1.5">{Math.floor((p.duration_sec || 0) / 60)} dk</td>
                  <td className={`px-3 py-1.5 font-bold ${pnlColor(p.net_pnl)}`}>{fmtUsd(p.net_pnl, 3)}</td>
                  <td className="px-3 py-1.5 text-[#94A3B8]" title={p.close_note || ""}>{p.close_reason_tr}</td>
                  <td className="px-2 py-1.5 whitespace-nowrap">
                    {confirmId === p.trade_id ? (
                      <span className="flex items-center gap-1">
                        <button data-testid={`history-delete-confirm-${p.trade_id}`} onClick={() => del(p)} className="text-[10px] font-semibold px-2 py-0.5 rounded bg-[#EF4444] text-white hover:bg-[#DC2626]">Sil</button>
                        <button data-testid={`history-delete-cancel-${p.trade_id}`} onClick={() => setConfirmId(null)} className="text-[10px] px-2 py-0.5 rounded border border-[#1E2738] text-[#94A3B8]">Vazgeç</button>
                      </span>
                    ) : (
                      <button data-testid={`history-delete-${p.trade_id}`} onClick={() => setConfirmId(p.trade_id)} title="Kaydı geçmişten ve bakiyeden sil" className="text-[#64748B] hover:text-[#EF4444] transition-colors"><Trash2 className="h-3.5 w-3.5" /></button>
                    )}
                  </td>
                </tr>))}
            </tbody>
          </table>
        </div>
      )}
      {tab === "skips" && (
        <div data-testid="guard-skips-list" className="bg-[#121724] border border-[#1E2738] rounded-lg p-3 space-y-1 font-mono text-[11px] max-h-80 overflow-y-auto">
          {skips.length === 0 && <div className="text-[#64748B] text-center py-4">Atlanan sinyal yok.</div>}
          {skips.map((k, i) => (
            <div key={i} className="flex gap-3 border-b border-[#1E2738]/50 pb-1">
              <span className="text-[#64748B] shrink-0">{fmtTime(k.ts)}</span><span className="font-semibold shrink-0 w-24">{k.symbol}</span>
              <span className="text-[#94A3B8]">{k.meta?.direction ? `${k.meta.direction} · ` : ""}{k.reason}</span>
            </div>))}
        </div>
      )}
    </div>
  );
}
